export const simpleChartStyles = {
  chartBox: {
    height: 5,
    alignItems: 'center',
  },
  chartItem: {
    height: 4,
  },
};
